export const MAX_ASPECTS_COLLAPSED = 4;
export const MAX_ASPECTS_EXPANDED = 8;

export const REVIEW_SUMMARY_OVERVIEW_ANCHOR_ID = 'review-summary-overview';
